import { render, staticRenderFns } from "./DateTimeLabel.vue?vue&type=template&id=9870f260&scoped=true&"
import script from "./DateTimeLabel.vue?vue&type=script&lang=js&"
export * from "./DateTimeLabel.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeLabel.vue?vue&type=style&index=0&id=9870f260&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9870f260",
  null
  
)

export default component.exports